import _classCallCheck from "@babel/runtime/helpers/classCallCheck";

var UnreachableException = function UnreachableException(value) {
  _classCallCheck(this, UnreachableException);

  return new Error("unreachable case: ".concat(JSON.stringify(value)));
};

export { UnreachableException as default };


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/_util/unreachableException.js
// module id = 547
// module chunks = 0